import { Pipe, PipeTransform } from '@angular/core';
import { CommentBase } from '@shared/api/api-loop/models/comment-base';
import { CommentChatModel, isChatComment } from '@dta/shared/models-api-loop/comment/comment.model';

@Pipe({
  name: 'isChatComment'
})
export class IsChatCommentPipe implements PipeTransform {
  transform(comment?: CommentBase): comment is CommentChatModel {
    return comment && isChatComment(comment);
  }
}
